import { FilePlusIcon, UploadIcon } from '@radix-ui/react-icons';
import { BaseballIcon } from 'components/common/custom-icon/shorthands';
import { ErrorBoundary } from 'components/common/error-boundary';
import { ImportSettingsPopover } from 'components/sections/game-data/import-settings-popover';
import { SectionHeader } from 'components/sections/header';
import { SectionName, SubSectionName } from 'enums/route.enums';
import { useActiveRoute } from 'hooks/useActiveRoute';
import { useNavSections } from 'hooks/useNavSections';
import { t } from 'i18next';
import { IMenuAction } from 'interfaces/i-menus';
import { useNavigate } from 'react-router-dom';
import { paths } from 'routes/paths';
import { useAuthStore } from 'stores/use-auth-store';
import useListLibraryStore from 'stores/use-list-library-store';

// also used for the PL header in library mode
export const PitchesHeader = (props: { extraActions?: IMenuAction[] }) => {
  const navigate = useNavigate();
  const { subsection } = useActiveRoute();
  const { userSections } = useNavSections();
  const isInGame = useAuthStore((s) => s.isInGame);

  return (
    <ErrorBoundary identifier="PitchesHeader">
      <SectionHeader
        header={t('main.pitches')}
        subsections={
          userSections.find((s) => s.value === SectionName.Pitches)?.subsections
        }
        secondaryAction={
          subsection === SubSectionName.GameData && <ImportSettingsPopover />
        }
        actions={[
          {
            group: '_1',
            prefixIcon: <FilePlusIcon />,
            label: 'common.create-pitch-list',
            disabled: isInGame,
            onClick: () => {
              useListLibraryStore.setState({
                dialogManage: {
                  key: Date.now(),
                  dialog: {
                    identifier: 'PitchesHeaderCreateListDialog',
                    mode: 'create',
                    onCreated: () =>
                      useListLibraryStore.setState({
                        dialogManage: undefined,
                      }),
                    onClose: () =>
                      useListLibraryStore.setState({
                        dialogManage: undefined,
                      }),
                  },
                },
              });
            },
          },
          {
            group: '_1',
            prefixIcon: <BaseballIcon />,
            label: 'common.create-pitch',
            disabled: isInGame,
            onClick: () => navigate(paths.pitches.design()),
          },
          {
            group: '_1',
            prefixIcon: <UploadIcon />,
            label: 'common.upload-pitches',
            disabled: isInGame,
            onClick: () => navigate(paths.pitches.upload),
          },
          ...(props.extraActions ?? []),
        ]}
      />
    </ErrorBoundary>
  );
};
